import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import * as globalVariables from "../../commonVariableList/addInvoice";
import { EesDesService } from '../../shared/services/ees-des.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';
@Component({
  selector: 'app-all-module-modal-popup',
  templateUrl: './all-module-modal-popup.component.html',
  styleUrls: ['./all-module-modal-popup.component.scss']
})
export class AllModuleModalPopupComponent implements OnInit {
  @Input() modalDetails: any;
  @ViewChild('allModuleModalContent') allModuleModalContent: ElementRef;
  // @Input() tableDetails: any;
  // @Input() approvalDetails: any;
  // @Input() divDetails: any;
  // @Input() attachment: any;

  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = {
    "actionsList": [{
      "name": "View",
      "icon": "fa fa-eye",
      "action": "view"
    }],
    "dataList": [],
    "columnList": [],
    "afterdivList": [],
    "beforedivList": [],
    "isProgressing": false,
    "modalDetails":{},
    "isPrView":false,
    "isPoView":false,
    "isIrnView":false,
    "isGrnView":false,
    "isInvoiceView":false,
    "name":'',
  };
  names:any={
    pr:this.webService.getMainMenuNameByGivenUrl('/raisepr'),
    po:this.webService.getMainMenuNameByGivenUrl('/raise-po'),
    irn:this.webService.getMainMenuNameByGivenUrl('/new-irn'),
    grn:this.webService.getMainMenuNameByGivenUrl('/add-grn'),
    invoice:this.webService.getMainMenuNameByGivenUrl('/add-invoice-v2'),
    ir:this.webService.getMainMenuNameByGivenUrl('/raiseir'),
  }

  constructor(public webService: WebServiceService,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,public eesdesService:EesDesService,
    private router: Router, private titleService: Title,public setup:CompanySetupService ) {
      this.initListener();
  }
  country_data:any={}
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  meta:any={}
  ngOnInit() {
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    this.sectionList2=[];
    if (this.modalDetails.data) {
      this.makeSetup()
    }
    document.getElementById('body').style.overflow = 'hidden';
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }

  getId(id: any, action: string, data: any) {
    this.sendAction.emit({
      "id": id,
      "action": action,
      "data": data,
    });
  }
  hideModal() {
    this.modalDetails.is_all = false;
    localStorage.setItem('dataList', '');
    document.getElementById('body').style.overflow = 'auto';
    this.sendAction.emit({ action: 'close' });
  }

  sectionList2:any=[];

  getModalCompanyId(data?: any): string {
    if (this.modalDetails && this.modalDetails.company_id != undefined && this.modalDetails.company_id !== null && this.modalDetails.company_id !== '') {
      return this.modalDetails.company_id.toString();
    }
    if (data && data.company_id != undefined && data.company_id !== null && data.company_id !== '') {
      return data.company_id.toString();
    }
    if (this.modalDetails && this.modalDetails.data && this.modalDetails.data.company_id != undefined && this.modalDetails.data.company_id !== null && this.modalDetails.data.company_id !== '') {
      return this.modalDetails.data.company_id.toString();
    }
    return this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId();
  }

  showAllData(data) {
    this.commonVariableList.dataList = [];
    let response: any = {};
    data.show_multi_inv = data.show_multi_inv ? data.show_multi_inv : '0';
    let payload: any = {
      invoice_id: data.id ? data.id : '',
      is_draft: data.is_draft ? data.is_draft : '',
      show_multi_inv: data.show_multi_inv,
      company_id: this.getModalCompanyId(data)
    };
    if (this.modalDetails.is_all_company_view != undefined && this.modalDetails.is_all_company_view !== null && this.modalDetails.is_all_company_view !== '') {
      payload.is_all_company_view = this.modalDetails.is_all_company_view;
    }
    this.commonVariableList.isProgressing = true;
    this.meta=this.modalDetails.meta?this.modalDetails.meta:{custom_name_for_supporting_document:'Supporting Document'}
    this.webService.commonPostMethod('/Invoices/get_full_invoice_details_v2', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            data.response.invoice= data.response.invoice? data.response.invoice:{"id":''}
            data.response.grn= data.response.grn.length>0? data.response.grn[0]:{"id":''}
            data.response.irn= data.response.irn.length>0? data.response.irn[0]:{"id":''}
            data.response.po= data.response.po.length>0? data.response.po[0]:{"id":''}
            data.response.pr= data.response.pr? data.response.pr:[]
            data.response.is_no_tds_deduction=data.is_no_tds_deduction?data.is_no_tds_deduction:0
            if(data.response.invoice.id!=undefined && data.response.invoice.id!='')
            {
              data.response.invoice.show_multi_inv = data.show_multi_inv;
              this.showInvoice(data.response.invoice);
            }
            if(data.response.grn.id!=undefined && data.response.grn.id!='')
            {
              this.showGrn(data.response.grn);
            }
            if(data.response.irn.id!=undefined && data.response.irn.id!='')
            {
              this.showIrn(data.response.irn);
            }
            if(data.response.po.id!=undefined && data.response.po.id!='')
            {
              data.response.po.po_items=data.response.po.items?data.response.po.items:[];
              this.showPo(data.response.po);
            }
            if(data.response.pr)
            {
              this.showPr(data.response.pr);
            }
            if(data.response.ir)
            {
              this.showIr(data.response.ir);
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
          }
          this.commonVariableList.isProgressing = false;

        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  initListener()
  {
    document.body.addEventListener('keypress', (event) => this.reset(event));
    document.body.addEventListener('keydown', (event) => this.reset(event));
    document.body.addEventListener('keyup', (event) => this.reset(event));

  }
  reset(event)
  {
    if(event.keyCode=='27')
    {
    this.modalDetails.is_view=false;
    this.modalDetails.is_all=false;

    document.body.style.overflow='auto';
    }
  }

  invoicesReportData: any;
  isInvoiceView: boolean = false;
  invoice_tableDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  invoice_approvalDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po Details', "Desscription": 'Po', "is_view": true,"final_approval_status": '0' }
  invoice_divDetails: any = { "data": {}, "id": "invoicereport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  invoice_attachment:any=[];
  supporting_document_attachment:any=[];
  credit_note_attachment:any=[];
  showInvoice(data) {
   console.log(data);

   data.bill_location_nickname_9_digit=data.bill_location_nickname_9_digit?data.bill_location_nickname_9_digit:''
   data.bill_location_code_9_digit=data.bill_location_code_9_digit?data.bill_location_code_9_digit:'';
   data.ship_location_nickname_9_digit=data.ship_location_nickname_9_digit?data.ship_location_nickname_9_digit:''
   data.ship_location_code_9_digit=data.ship_location_code_9_digit?data.ship_location_code_9_digit:'';
   data.info_History=data.info_History?data.info_History:[]
   data.is_need_info=data.is_need_info?data.is_need_info:false;
   data.company_bank_name = data.bank_name ? data.bank_name : '';
   data.ship_location=data.ship_location?data.ship_location:'';
   data.is_custom_ship_to_location=data.is_custom_ship_to_location?data.is_custom_ship_to_location:'0';
   data.common_ship_location=data.ship_location_nickname_9_digit
   if(data.ship_location_code_9_digit!=''&&data.ship_location_code_9_digit!=undefined&&data.ship_location_code_9_digit!=null)
   {
     data.common_ship_location=data.common_ship_location + " (" + data.ship_location_code_9_digit + ")";

   }   data.company_bank_accountno = data.bank_accountno ? data.bank_accountno : '';
   if(data.invoice_items)
   {
     for(let i of data.invoice_items)
     {

      if ( data.is_custom_ship_to_location == '0') {
        i.location=data.ship_location

        i.ship_to_location_gst_no=i.ship_to_location_gst_no?i.ship_to_location_gst_no:''
        if(i.ship_to_location_gst_no!=null&&i.ship_to_location_gst_no!='')
        {
          if(this.country_data.country_id=='101')
          {
          i.location=i.location+"( GST - "+i.ship_to_location_gst_no+")";
          i.ship_location=i.ship_location+"( GST - "+i.ship_to_location_gst_no+")";
          }
          else
          {
            i.location=i.location
            i.ship_location=i.ship_location
          }
        }

      }
      if ( data.is_custom_ship_to_location == '1') {
        i.location=data.custom_ship_to_location

      }
       i.tds_section_name = i.tds_section_name ? i.tds_section_name : '';
       i.tds_rate = i.tds_rate ? i.tds_rate : i.vendor_tds_rate;
       i.account_name = `${i.account_name} (${i.account_code})`
       i.tds_rate = parseFloat(i.tds_rate);
       i.product_name=i.product_name+"("+i.productcode+")";
       i.location=i.ship_location?i.ship_location:i.location;

     }
   }

   data.po_no=data.is_multi_grn_invoice=='0'?data.invoice_items[0].po_no:''
   data.po_date=data.is_multi_grn_invoice=='0'?data.invoice_items[0].po_date:''
   data.irn_cs_id=data.is_multi_grn_invoice=='0'?data.invoice_items[0].irn_cs_id:''
   data.irn_date=data.is_multi_grn_invoice=='0'?data.invoice_items[0].irn_date:''
   data.grn_cs_id=data.is_multi_grn_invoice=='0'?data.invoice_items[0].grn_cs_id:''
   data.grn_date=data.is_multi_grn_invoice=='0'?data.invoice_items[0].grn_date:''
   data.vendor_address=data.is_multi_grn_invoice=='0'?data.invoice_items[0].vendor_address:data.invoice_items[0].vendor_address
  //  data.msme = data.invoice_items[0].msme ? data.invoice_items[0].msme : '0';
   data.bill_location_nickname_9_digit=data.invoice_items[0].bill_location_nickname_9_digit?data.invoice_items[0].bill_location_nickname_9_digit:''
   data.bill_location_code_9_digit=data.invoice_items[0].bill_location_code_9_digit?data.invoice_items[0].bill_location_code_9_digit:''
   data.ship_location_nickname_9_digit=data.invoice_items[0].ship_location_nickname_9_digit?data.invoice_items[0].ship_location_nickname_9_digit:''
   data.ship_location_code_9_digit=data.invoice_items[0].ship_location_code_9_digit?data.invoice_items[0].ship_location_code_9_digit:''
   data.ship_to_location_gst_no=data.ship_to_location_gst_no?data.ship_to_location_gst_no:''

   if(data.ship_to_location_gst_no!='')
   {
    if(this.country_data.country_id=='101')
    {
      data.common_ship_location=data.common_ship_location+"(GST - "+data.ship_to_location_gst_no+")"
    }
    else
    {
      data.common_ship_location=data.common_ship_location
    }
   }
   if(data.is_multi_grn_invoice=='0')
   {
     data.common_ship_location='';
   }

   data.advance_amount=data.advance_amount?data.advance_amount:'';
   
   // Extract irn_no and eway_bill_number from scanned_invoice_meta or ocr_suggestions
   try {
     if (data.scanned_invoice_meta) {
       let scannedMeta;
       if (typeof data.scanned_invoice_meta === 'string') {
         scannedMeta = JSON.parse(data.scanned_invoice_meta);
       } else {
         scannedMeta = data.scanned_invoice_meta;
       }
       if (scannedMeta && scannedMeta.field_data) {
         if (scannedMeta.field_data.irn_no && scannedMeta.field_data.irn_no.value) {
           data.irn_no = scannedMeta.field_data.irn_no.value;
         }
         if (scannedMeta.field_data.eway_bill_number && scannedMeta.field_data.eway_bill_number.value) {
           data.eway_bill_number = scannedMeta.field_data.eway_bill_number.value;
         }
       }
     }
     // Also check ocr_suggestions as fallback
     if ((!data.irn_no || !data.eway_bill_number) && data.ocr_suggestions) {
       let ocrSuggestions;
       if (typeof data.ocr_suggestions === 'string') {
         ocrSuggestions = JSON.parse(data.ocr_suggestions);
       } else {
         ocrSuggestions = data.ocr_suggestions;
       }
       if (ocrSuggestions) {
         if (!data.irn_no && ocrSuggestions.irn_no) {
           data.irn_no = typeof ocrSuggestions.irn_no === 'object' && ocrSuggestions.irn_no.value 
             ? ocrSuggestions.irn_no.value 
             : ocrSuggestions.irn_no;
         }
         if (!data.eway_bill_number && ocrSuggestions.eway_bill_number) {
           data.eway_bill_number = typeof ocrSuggestions.eway_bill_number === 'object' && ocrSuggestions.eway_bill_number.value 
             ? ocrSuggestions.eway_bill_number.value 
             : ocrSuggestions.eway_bill_number;
         }
       }
     }
     // Ensure values are set (even if empty string)
     if (data.irn_no === undefined || data.irn_no === null) {
       data.irn_no = '';
     }
     if (data.eway_bill_number === undefined || data.eway_bill_number === null) {
       data.eway_bill_number = '';
     }
   } catch (e) {
     console.error('Error parsing scanned_invoice_meta or ocr_suggestions:', e);
     // If parsing fails, ensure values are set
     if (data.irn_no === undefined || data.irn_no === null) {
       data.irn_no = '';
     }
     if (data.eway_bill_number === undefined || data.eway_bill_number === null) {
       data.eway_bill_number = '';
     }
   }
   
    this.invoicesReportData = {};
    this.invoicesReportData = data;
    this.invoicesReportData.irn_cs_id=data.irn_cs_id;
    this.invoicesReportData.grn_cs_id=data.grn_cs_id;
    this.invoicesReportData.invoice_cs_id=data.invoice_cs_id;
    this.invoicesReportData.invoice_payment_cs_id=data.invoice_payment_cs_id;
    this.invoicesReportData.vendor_address=data.vendor_address;
    this.invoicesReportData.msme=data.msme;

    // Map mailed_irn_no and mailed_eway_bill_no to irn_no and eway_bill_number for UI display
    data.irn_no = data.mailed_irn_no ? data.mailed_irn_no : '';
    data.eway_bill_number = data.mailed_eway_bill_no ? data.mailed_eway_bill_no : '';

    this.invoice_divDetails.data={}
    this.invoice_divDetails.data=data;
    this.invoice_approvalDetails.data={}
    this.invoice_approvalDetails.data=data;
    this.invoice_approvalDetails.final_approval_status = data.final_approval_status ? data.final_approval_status : '0';

    // this.invoice_approvalDetails.data.approvals=data.approvals?data.approvals:[];


    this.invoice_tableDetails.data={}
    this.invoice_tableDetails.data=data;
    this.invoice_attachment=[];
    this.invoicesReportData.attachment = [];
    let attachment: any = [];
    attachment = data.attachments ? data.attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.invoicesReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.invoice_attachment=this.invoicesReportData.attachment?this.invoicesReportData.attachment:[];

      this.supporting_document_attachment=[];
    let supporting_document_attachment: any = [];
    supporting_document_attachment = data.supporting_document_attachment ? data.supporting_document_attachment : []
    if (supporting_document_attachment)
    {
      for (let d of supporting_document_attachment) {
        this.supporting_document_attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
    this.credit_note_attachment=[];
    let credit_note_attachment: any = [];
    credit_note_attachment = data.credit_note_attachment ? data.credit_note_attachment : []
    if (credit_note_attachment)
    {
      for (let d of credit_note_attachment) {
        this.credit_note_attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachments_url,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
// console.log(this.supporting_document_attachment)
// console.log(data.supporting_document_attachment)

      this.commonVariableList.isInvoiceView = true;


  }
  grnsReportData: any;
  isGrnView: boolean = false;
  grn_tableDetails: any = { "data": {}, "id": "grnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  grn_approvalDetails: any = { "data": {}, "id": "grnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  grn_divDetails: any = { "data": {}, "id": "grnreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  grn_attachement:any=[];
  showGrn(data) {


    this.commonVariableList.isGrnView = true;
    if(data.approvals)
  {
    for(let i of data.approvals)
    {
      i.approval_first_name=i.approval_first_name?i.approval_first_name:i.first_name;
      i.approval_last_name=i.approval_last_name?i.approval_last_name:i.last_name
    }
  }
    data.employee_code=data.added_by_employee_code?data.added_by_employee_code:''
    data.bill_location_nickname_9_digit = data.bill_name?data.bill_name:''
    data.bill_location_code_9_digit =data.bill_location_code_9_digit?data.bill_location_code_9_digit:''
    data.ship_location_nickname_9_digit=data.ship_name?data.ship_name:''
    data.ship_location_code_9_digit=data.ship_location_code_9_digit?data.ship_location_code_9_digit:'';
    // data.bill_to_location = data.bill_name + " (" + data.bill_location_code_9_digit + ")";
    // data.ship_to_location = data.ship_name + " (" + data.ship_location_code_9_digit + ")";
    if (data.grn_items) {
      let sl_no: number = 1;

      for (let j of data.grn_items) {
        j.is_closed = j.is_closed == '1' ? true : false;
        j.send_damage_mail = j.send_damage_mail == "1" ? true : false;
        j.sl_no = sl_no;
        j.product_name=j.product_name+"("+j.productcode+")";

        sl_no++;
      }
    }
    this.grnsReportData = {};
    this.grnsReportData = data;
    this.grnsReportData.irn_cs_id=data.irn_cs_id;
    this.grnsReportData.grn_cs_id=data.grn_cs_id;
    this.grnsReportData.po_no=data.po_id?data.po_id:'';

    this.grnsReportData.attachment = [];


    this.grn_divDetails.data={}
    this.grn_divDetails.data=data;
    this.grn_approvalDetails.data={}
    this.grn_approvalDetails.data=data;

    this.grn_tableDetails.data={}
    this.grn_tableDetails.data=data;
    this.grn_attachement=[];

    let attachment: any = [];
    attachment = data.grn_attachments ? data.grn_attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.grnsReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachment_name,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.grn_attachement=attachment?attachment:[];

  }




  irnReportData: any;
  isIrnView: boolean = false;
  irn_tableDetails: any = { "data": {}, "id": "irnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  irn_approvalDetails: any = { "data": {}, "id": "irnreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  irn_divDetails: any = { "data": {}, "id": "irnreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  irn_attachement:any=[];
  showIrn(data) {


    this.commonVariableList.isIrnView = true;
  //   data.approvals=[];
  //   data.approvals.push({"approval_status":data.approval_status,"employee_code":data.approval_employee_code,
  //   "approval_first_name":data.approval_first_name,"approval_last_name":data.approval_last_name,
  // "date_added":data.date_added,"date_updated":data.date_updated,"approval_by":data.approval_by,'reason':''})
  if(data.approvals)
  {
    for(let i of data.approvals)
    {
      i.approval_first_name=i.approval_first_name?i.approval_first_name:i.first_name;
      i.approval_last_name=i.approval_last_name?i.approval_last_name:i.last_name
    }
  }
    this.irnReportData = {};
    this.irnReportData = data;
    this.irnReportData.irn_cs_id=data.irn_cs_id;
    this.irnReportData.attachment = [];
    this.irnReportData.date_added=this.webService.formatDate(new Date(data.date_added),'yy-mm-dd','-')
    this.irnReportData.date_updated=this.webService.formatDate(new Date(data.date_updated),'yy-mm-dd','-')

    data.bill_to_location=data.bill_to_location_name?data.bill_to_location_name:'';
    data.ship_to_location=data.ship_to_location_name?data.ship_to_location_name:'';
if(data.irn_items)
{
  for(let d of data.irn_items)
  {
    d.is_damaged = d.is_damaged == "1" ? true : false;
    d.product_name=d.product_name+"("+d.productcode+")";

  }
}

    this.irn_divDetails.data={}
    this.irn_divDetails.data=data;
    this.irn_divDetails.data.requested_by_first_name=data.added_by_first_name?data.added_by_first_name:'';
    this.irn_divDetails.data.requested_by_last_name=data.added_by_last_name?data.added_by_last_name:'';
    this.irn_divDetails.data.requested_by_employee_code=data.added_by_employee_code?data.added_by_employee_code:'';

    this.irn_approvalDetails.data={}
    this.irn_approvalDetails.data=data;

    this.irn_tableDetails.data={}
    this.irn_tableDetails.data=data;
    this.irn_attachement=[];

    let attachment: any = [];
    attachment = data.irn_attachments ? data.irn_attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.irnReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachment_name,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }
      this.irn_attachement=attachment?attachment:[];

  }
  poReportData: any;
  isPoView: boolean = false;

  po_tableDetails: any = { "data": {}, "id": "poreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  po_approvalDetails: any = { "data": {}, "id": "poreport", "name": 'Po Details', "Desscription": 'Po', "is_view": true }
  po_divDetails: any = { "data": {}, "id": "poreport", "name": 'Po div Details', "Desscription": 'Po divs ', "is_view": true }
  po_attachement:any=[];
  showPo(data) {


    this.commonVariableList.isPoView = true;
    data.requested_by_employee_code=data.requested_by_employeecode?data.requested_by_employeecode:'';
    data.ship_to_location=data.ship_to_location_name.location?data.ship_to_location_name.location:'';
    data.bill_location_nickname_9_digit=data.bill_to_location_name.location_nickname_9_digit?data.bill_to_location_name.location_nickname_9_digit:''
    data.bill_location_code_9_digit=data.bill_to_location_name.location_code_9_digit?data.bill_to_location_name.location_code_9_digit:'';

    data.is_rented = data.is_rented == "1" ? true : false;
    data.is_different_document_currency = data.is_different_document_currency == "1" ? true : false;
    data.is_boq = data.is_boq == "1" ? true : false;
    data.high_sea_level = data.high_sea_level == "1" ? true : false;

    this.sectionList2 = data.adhoc_advance_payment_section_list;
    // Add this line:
    data.sectionList2 = this.sectionList2; // Pass to tableDetails
    // Then set the table details
    this.po_tableDetails.data = data;

    data.exclude_gst = data.exclude_gst == "1" ? true : false;

    if(data.items)
    {
      for(let i of data.items)
      {
        i.is_logistic = i.is_logistic == '1' ? true : false;
        i.ship_to_location= data.ship_to_location? data.ship_to_location:'';
        i.product_name=i.product_name+"("+i.productcode+")";



        i.amend_po_status=i.is_amend=='1'?'Closed':'';
        i.amend_po_qty=i.is_amend=='1'?i.close_po_qty:'';
        i.amend_date=i.amend_date?i.amend_date:'';
        i.amend_added_by=i.amend_added_by?i.amend_added_by:'';
      }
    }
    this.poReportData = {};
    this.poReportData = data;
    this.poReportData.attachment = [];

    this.po_divDetails.data={}
    this.po_divDetails.data=data;
    this.po_approvalDetails.data={}
    this.po_approvalDetails.data=data;

    this.po_tableDetails.data={}
    this.po_tableDetails.data=data;
    this.po_attachement=[];

    let attachment: any = [];
    attachment = data.po_attachments ? data.po_attachments : []
    if (attachment)
    {
      for (let d of attachment) {
        this.poReportData.attachment.push({
          "url": d.attachments_url,
          "name": d.attachment_name,
          "display": d.attachment_name,
          "filename": d.attachment_name,
          "filetype": this.webService.getFileExtension(d.attachment),
          "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
        });
      }
    }

      this.po_attachement=attachment?attachment:[];

  }
  prReportData: any;
  pr_tableDetails: any = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  pr_approvalDetails: any = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  pr_divDetails: any = { "data": {}, "id": "prreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
  pr_attachement:any=[];
  isPrView: boolean = false;
  prData:any=[];
  showPr(data) {
    console.log("inside all module",data)
    this.prData=[];
    this.prReportData = {};
    this.pr_attachement=[];
    if(data)
    {
      for(let i of data)
      {
        i.is_boq=i.is_boq=='1'?true:false

        if(i.pr_items)
        {
          for(let j of i.pr_items)
          {
            j.product_name=j.product.product_name?j.product.product_name:''
            j.productcode=j.product.productcode?j.product.productcode:''
            j.product_type=j.product.product_type?j.product.product_type:''
            j.product_catalog_id=j.product.product_catalog_id?j.product.product_catalog_id:''
            j.product_name=j.product_name+"("+j.productcode+")";


          }
        }
        i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"

        i.customer_detail='';
        // if(i.customer_first_name!='' &&i.customer_first_name!=undefined)
        // {
        // i.customer_detail=i.customer_first_name+" "+i.customer_last_name+" ("+i.customer_code+")";
        // }
        // if(i.customer_address!='' && i.customer_address!=null)
        // {
         i.customer_detail=i.customer_address?i.customer_address:'';
         i.customer_details=i.customer_address?i.customer_address:'';

        // }

        if(i.approvals)
        {
        for (let x of i.approvals) {
          x.employee_code = x.user.employee_code;
          x.approval_first_name = x.user.first_name;
          x.approval_last_name = x.user.last_name;
        }
      }
        i.location=i.location.location?i.location.location:'';
        i.pr_tableDetails = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.pr_approvalDetails = { "data": {}, "id": "prreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.pr_divDetails = { "data": {}, "id": "prreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
        i.pr_divDetails.data={}
        i.pr_divDetails.data=i;
        i.pr_approvalDetails.data={}
        i.pr_approvalDetails.data=i;

        i.pr_tableDetails.data={}
        i.pr_tableDetails.data=i;
        i.pr_attachement=[];

        let attachment: any = [];
        attachment = i.attachments ? i.attachments : []
        if (attachment)
          for (let d of attachment) {
            this.pr_attachement.push({
              "url": d.attachments_url,
              "name": d.attachment_name,
              "display": d.attachments_url?d.attachments_url:'',
              "filename": d.attachment_name,
              "filetype": this.webService.getFileExtension(d.attachment),
              "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
            });
          }
    i.pr_attachement=this.pr_attachement?this.pr_attachement:[];
        this.prData.push(i)
      }
    }
    this.commonVariableList.isPrView = true;


  }

  irReportData: any;
  ir_tableDetails: any = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  ir_approvalDetails: any = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
  ir_divDetails: any = { "data": {}, "id": "irreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
  ir_attachement:any=[];
  isIrView: boolean = false;
  irData:any=[];
  showIr(data) {
    console.log("inside all module",data)
    this.irData=[];
    this.irReportData = {};
    this.ir_attachement=[];
    if(data)
    {
      for(let i of data)
      {
        i.is_boq=i.is_boq=='1'?true:false

        if(i.ir_items)
        {
          for(let j of i.ir_items)
          {
            j.product_name=j.product.product_name?j.product.product_name:''
            j.productcode=j.product.productcode?j.product.productcode:''
            j.product_type=j.product.product_type?j.product.product_type:''
            j.product_catalog_id=j.product.product_catalog_id?j.product.product_catalog_id:''

          }
        }
        i.requested_by = i.user.first_name + " " + i.user.last_name + " (" + i.user.employee_code + ")"

        if(i.approvals)
        {
        for (let x of i.approvals) {
          x.employee_code = x.user.employee_code;
          x.approval_first_name = x.user.first_name;
          x.approval_last_name = x.user.last_name;
        }
      }
        i.location=i.location.location?i.location.location:'';
        i.ir_tableDetails = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true}
        i.ir_approvalDetails = { "data": {}, "id": "irreport", "name": 'Pr Details', "Desscription": 'Pr', "is_view": true }
        i.ir_divDetails = { "data": {}, "id": "irreport", "name": 'Pr div Details', "Desscription": 'Pr divs ', "is_view": true }
        i.ir_divDetails.data={}
        i.ir_divDetails.data=i;
        i.ir_approvalDetails.data={}
        i.ir_approvalDetails.data=i;

        i.ir_tableDetails.data={}
        i.ir_tableDetails.data=i;
        i.ir_attachement=[];

        let attachment: any = [];
        attachment = i.attachments ? i.attachments : []
        if (attachment)
          for (let d of attachment) {
            this.pr_attachement.push({
              "url": d.attachments_url,
              "name": d.attachment_name,
              "display": d.attachment_name,
              "filename": d.attachment_name,
              "filetype": this.webService.getFileExtension(d.attachment),
              "iconclass": this.webService.getFileIcon(this.webService.getFileExtension(d.attachment)),
            });
          }
    i.ir_attachement=this.ir_attachement?this.ir_attachement:[];
        this.irData.push(i)
      }
    }
    this.commonVariableList.isIrView = true;


  }
  makeSetup()
{
  let is_setup=this.modalDetails.is_setup?this.modalDetails.is_setup:false
  let setup=this.modalDetails.setup?this.modalDetails.setup:this.setup.getData()
  const modalCompanyId = this.getModalCompanyId(this.modalDetails.data);
  const homeCompanyId = this._localStorageService.getEmpCompanyId()
    ? this._localStorageService.getEmpCompanyId().toString()
    : '';
  this.invoice_divDetails.is_setup=is_setup
  this.invoice_divDetails.setup=setup
  this.invoice_divDetails.is_invoice_approval_screen = this.modalDetails.is_invoice_approval_screen == true;
  this.invoice_tableDetails.is_setup=is_setup
  this.invoice_tableDetails.setup=setup
  if (modalCompanyId && modalCompanyId !== homeCompanyId) {
    this.invoice_tableDetails.is_setup = false;
    this.invoice_tableDetails.setup = {};
  }

  this.po_divDetails.is_setup=is_setup
  this.po_divDetails.setup=setup
  this.po_tableDetails.is_setup=is_setup
  this.po_tableDetails.setup=setup

  this.pr_divDetails.is_setup=is_setup
  this.pr_divDetails.setup=setup
  this.pr_tableDetails.is_setup=is_setup
  this.pr_tableDetails.setup=setup

  this.irn_divDetails.is_setup=is_setup
  this.irn_divDetails.setup=setup
  this.irn_tableDetails.is_setup=is_setup
  this.irn_tableDetails.setup=setup

  this.grn_divDetails.is_setup=is_setup
  this.grn_divDetails.setup=setup
  this.grn_tableDetails.is_setup=is_setup
  this.grn_tableDetails.setup=setup
  this.showAllData(this.modalDetails.data);

}
}



// WEBPACK FOOTER //
// /codebuild/output/src2648113480/src/src/app/generic-ui-components/all-module-modal-popup/all-module-modal-popup.component.ts